import { create } from 'zustand';
import type { Session } from '@supabase/supabase-js';
import type { Tables } from '../types/database.types';

export interface AuthStore {
  session: Session | null;
  collaborator: Tables<'collaborators'> | null;
  clientUser: Tables<'client_users'> | null;
  isInitialized: boolean;
  /** true une fois le fetch d'identité (collaborator/client) résolu — évite le flash "Compte non configuré". */
  identityResolved: boolean;
  setSession: (s: Session | null) => void;
  setCollaborator: (c: Tables<'collaborators'> | null) => void;
  setClientUser: (c: Tables<'client_users'> | null) => void;
  setInitialized: (v: boolean) => void;
  setIdentityResolved: (v: boolean) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  session: null,
  collaborator: null,
  clientUser: null,
  isInitialized: false,
  identityResolved: false,
  setSession: (s) => set({ session: s }),
  setCollaborator: (c) => set({ collaborator: c }),
  setClientUser: (c) => set({ clientUser: c }),
  setInitialized: (v) => set({ isInitialized: v }),
  setIdentityResolved: (v) => set({ identityResolved: v }),
  clear: () =>
    set({
      session: null,
      collaborator: null,
      clientUser: null,
      isInitialized: false,
      identityResolved: false,
    }),
}));

export const selectIsAuthenticated = (s: AuthStore): boolean => !!s.session;
export const selectRole = (s: AuthStore): string | null => s.collaborator?.role ?? null;
export const selectIsAdmin = (s: AuthStore): boolean => s.collaborator?.role === 'admin';
export const selectIsClient = (s: AuthStore): boolean => !!s.clientUser;
